import React from 'react';
import { FreshIcon, Cryopreserve } from "../../../assets/CommonSvg"

const ReferenceSection = ({ className = "" }) => {
  const references = [
    { label: "Fresh Apheresis", template: FreshIcon  },
    { label: "Cryopreserved LSM", template: Cryopreserve }
  ];

  return (
    <div className={`reference-section flex gap-3 mb-3 ${className}`}>
      <h4 className="text-sm font-semibold text-gray-700">Reference:</h4>
      <div className="flex gap-2">
        {references.map((ref, index) => (
          <div key={index} className="flex gap-2">
           {React.createElement(ref.template)}
            <span className="text-xs text-black-400">{ref.label}</span>
            {/* Add pinpine after text except for last item */}
            {index < references.length - 1 && (
              <span className="text-[##CFD6DC]-400">|</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferenceSection;